import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./login.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./login.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AppConfig } from "../../app.config";
import { takeUntil } from "rxjs/operators";
import { LoginConstants } from "./login.constants";
import { FormErrorStateMatcher } from "../../shared/classes/error-state-matcher";
import { AppControllerService } from "../../app-controller.service";
import { AlertType } from "../../shared/models/alert";
import { Subject } from "rxjs";
let LoginComponent = class LoginComponent {
    dialogRef;
    appController;
    loginErrorStateMatcher;
    ngUnsubscribe = new Subject();
    usernamePlaceHolderText = LoginConstants.USERNAME_TEXT;
    passwordPlaceHolderText = LoginConstants.PASSWORD_TEXT;
    usernameRequiredErrorText = LoginConstants.USERNAME_REQUIRED_TEXT;
    passwordRequiredErrorText = LoginConstants.PASSWORD_REQUIRED_TEXT;
    dialogTitle = LoginConstants.LOGIN_DIALOGUE_TITLE;
    loginButtonText = LoginConstants.LOGIN_BUTTON_TEXT;
    loginErrorText = LoginConstants.LOGIN_ERROR_TEXT;
    spinnerDiameter = LoginConstants.LOGIN_SPINNER_DIAMETER;
    spinnerMode = LoginConstants.LOGIN_SPINNER_MODE;
    loginFormGroup;
    loginInProgress = false;
    loginErrorOccured = false;
    constructor(dialogRef, appController, loginErrorStateMatcher) {
        this.dialogRef = dialogRef;
        this.appController = appController;
        this.loginErrorStateMatcher = loginErrorStateMatcher;
    }
    get username() {
        return this.loginFormGroup.get(LoginConstants.USERNAME_FORM_CONTROL);
    }
    get password() {
        return this.loginFormGroup.get(LoginConstants.PASSWORD_FORM_CONTROL);
    }
    ngOnInit() {
        this.loginFormGroup = new FormGroup({
            username: new FormControl("", [Validators.required]),
            password: new FormControl("", [Validators.required])
        });
        this.trackChangesForLoginError();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngAfterContentInit() {
        if (AppConfig !== undefined && AppConfig !== null && AppConfig.settings.testing && AppConfig.settings.testing.enabled) {
            this.username.setValue(AppConfig.settings.testing.username);
            this.password.setValue(AppConfig.settings.testing.password);
            this.login();
        }
    }
    loginDisabled() {
        return !this.loginFormGroup.valid || this.loginInProgress;
    }
    hasUsernameRequiredError() {
        return this.username.hasError(LoginConstants.REQUIRED_ERROR_CODE);
    }
    hasPasswordRequiredError() {
        return this.password.hasError(LoginConstants.REQUIRED_ERROR_CODE);
    }
    login() {
        /*   this.loginInProgress = true;
           this.authService.authenticate(this.username.value, this.password.value)
             .pipe(takeUntil(this.ngUnsubscribe))
             .subscribe((userResult: IUserResult) => {
               this.handleAuthenticationResult(userResult);
               this.loginInProgress = false;
             }, error => {
               this.loginErrorOccured = true;
               this.loginInProgress = false;
             });*/
    }
    handleAuthenticationResult(userResult) {
        if (userResult.resultStatus.success) {
            this.appController.showMessage("Successfully logged in.", AlertType.Success);
            this.close(true);
        }
        else {
            this.loginErrorOccured = true;
            this.loginInProgress = false;
        }
    }
    close(loginSuccessful) {
        this.dialogRef.close(loginSuccessful);
    }
    trackChangesForLoginError() {
        this.username.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(value => {
            if (this.loginErrorOccured) {
                this.loginErrorOccured = false;
            }
        });
        this.password.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(value => {
            if (this.loginErrorOccured) {
                this.loginErrorOccured = false;
            }
        });
    }
    static ctorParameters = () => [
        { type: MatDialogRef },
        { type: AppControllerService },
        { type: FormErrorStateMatcher }
    ];
};
LoginComponent = __decorate([
    Component({
        selector: "app-login",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], LoginComponent);
export { LoginComponent };
